import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,[_c(VCardText,[_c(VCardTitle,{staticClass:"titulopagina"},[_vm._v("LISTADO DE FOLIOS PCC4")])],1)],1),_c(VCard,{staticClass:"mt-2"},[_c('tabla-paginada',{on:{"cargar":function($event){return _vm.cargar($event)}},scopedSlots:_vm._u([{key:"conforme_nc",fn:function(props){return [_c(VCheckbox,{attrs:{"input-value":props.item.conforme_nc,"label":"conforme/nc"},on:{"change":function($event){return _vm.updateConformeNc(props.item)}}})]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }